export const NO_TIMEZONE_ERROR =
  "Unexpected lack of user's timezone. Make sure that you are logged and the timezone is defined";
